import React from 'react'
import './OurPromises.css'
import CountUp from 'react-countup'


const OurPromises = () => {
  return (
    <div className='promises'>
        <div className="promises-badge">
            <p>So Far.....</p>
        </div>
        <div className="promises-section">
            <div className="promises-left">
                <h2>Our Promises</h2>
                <p className='promises-text'>With a strong focus on customer satisfaction, we are 
                    dedicated to building lasting relationships with our 
                   clients by delivering exceptional service and support.
                </p>
                <h4>Our Values:</h4>
                <ul>
                    <li>Innovation: We are constantly seeking new ways to improve our 
                        services and enhance the customer experience.
                    </li>
                    <li>
                        Reliability: We are committed to providing reliable and secure payment solutions.
                    </li>
                    <li>
                        Accessibility: We aim to make our services accessible to everyone, regardless of their 
                        location or technological proficiency.
                    </li>
                    <li>
                    Customer Focus: Our customers are at the heart of everything we do.
                    </li>
                </ul>
                <p className='promises-text'>Join us in shaping the future of payments. Choose <span>Sendcheap</span>.</p>
            </div>
            <div className="promises-right">
                <h2>We believe in the <br /> power of data</h2>
                <p className='right-text'> 
                    SendCheap is the only business platform that lets you run your business on one platform, seamlessly 
                    across all digital channels.
                </p>
                <div className="promises-right-info">
                    <div className="info">
                        <h3>
                            <CountUp enableScrollSpy duration={2} end={235000}/>
                        </h3>
                        <p>Happy Customers</p>
                    </div>
                    <div className="info">
                        <h3>
                            +<CountUp enableScrollSpy duration={2} end={+50000} />
                        </h3>
                        <p>Amount Saved</p>
                    </div>
                    <div className="info">
                        <h3>
                            $<CountUp enableScrollSpy duration={2} end={10} />m
                        </h3>
                        <p>Total Transactions</p>
                    </div>
                    <div className="info">
                        <h3>
                            <CountUp enableScrollSpy duration={2} end={1} />
                        </h3>
                        <p>Years in Business</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default OurPromises
